var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHeartBadge = function SvgHeartBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D07F9A",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#1F1F1F",
    cx: 12,
    cy: 12,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.835 7.967c-1.284-1.094-3.194-.897-4.373.319L12 8.762l-.462-.476C10.362 7.07 8.45 6.873 7.165 7.967c-1.472 1.256-1.55 3.511-.232 4.873l4.535 4.683a.735.735 0 001.062 0l4.535-4.683c1.32-1.362 1.242-3.617-.23-4.873z",
    fill: "#1F1F1F",
    fillRule: "nonzero"
  }))));
};

export default SvgHeartBadge;